<template>
    <v-dialog :value="showModal" max-width="500px">
        <v-overlay :value="loadingWorkOrders">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>

        <v-card>
            <v-card-title>
                <span class="headline">{{ t("Pull work order from ODOO") }}</span>
            </v-card-title>
            <v-card-text>
                <v-autocomplete
                    v-model="selectedItem"
                    :items="odooWorkOrders"
                    :label="t('Select Work Order from Odoo')"
                    item-text="ext_name"
                    :loading="loadingOdooWorkOrders"
                    return-object
                ></v-autocomplete>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="cancel">{{ t("Cancel") }}</v-btn>
                <v-btn @click="confirm" color="primary">{{ t("Confirm") }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Store from "@/store";
import settings from "@/settings";

export default {
    data() {
        return {
            selectedItem: null
        };
    },
    props: {
        showModal: Boolean
    },
    computed: {
        ...mapState("WorkOrderStore", ["odooWorkOrders", "loadingOdooWorkOrders", "loadingWorkOrders"])
    },
    methods: {
        ...mapMutations("WorkOrderStore", ["setForcePullFromOdooModalVisible"]),
        ...mapActions("WorkOrderStore", ["submitForcePullWorkOrderFromOdooData", "fetchWorkOrders"]),
        cancel() {
            this.setForcePullFromOdooModalVisible(false);
        },
        async confirm() {
            await this.submitForcePullWorkOrderFromOdooData(this.selectedItem);
            this.selectedItem = null;
            this.setForcePullFromOdooModalVisible(false);
            await this.fetchWorkOrders({});
        }
    }
};
</script>

<style scoped>
/* Add your component-specific styles here */
</style>
